import { Database, Plus, Search, Users } from 'lucide-react'
import { Button, ListToolbar } from '../components/ui'

interface StudentsV2ToolbarProps {
  filter: string
  studentCount: number
  canAddStudent: boolean
  canSyncLdap: boolean
  ldapLoading: boolean
  showStudentList: boolean
  onFilterChange: (value: string) => void
  onAddStudent: () => void
  onLdapSync: () => void
  onToggleStudentList: () => void
}

export default function StudentsV2Toolbar({
  filter,
  studentCount,
  canAddStudent,
  canSyncLdap,
  ldapLoading,
  showStudentList,
  onFilterChange,
  onAddStudent,
  onLdapSync,
  onToggleStudentList
}: StudentsV2ToolbarProps) {
  return (
    <ListToolbar
      title="Schüler"
      description="Neu strukturiertes Master-Detail-Layout mit Segment-Navigation."
      trailing={
        <>
          <label htmlFor="students-v2-search" className="sr-only">
            Schüler suchen
          </label>
          <div className="relative w-full min-w-[16rem] sm:w-auto">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400 dark:text-gray-500" />
            <input
              id="students-v2-search"
              type="search"
              placeholder="Name, Vorname oder Klasse …"
              value={filter}
              onChange={(event) => onFilterChange(event.target.value)}
              className="input-field min-h-[2.25rem] w-full py-2 pl-9 text-sm sm:w-72"
            />
          </div>
          <span className="inline-flex items-center gap-1 rounded-md border border-gray-200 bg-gray-50 px-2 py-1 text-xs text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
            <Users className="h-3.5 w-3.5" />
            {studentCount} Schüler
          </span>
          {canAddStudent ? (
            <Button size="sm" onClick={onAddStudent}>
              <Plus className="mr-1 h-4 w-4" />
              Hinzufügen
            </Button>
          ) : null}
          {canSyncLdap ? (
            <Button size="sm" onClick={onLdapSync} disabled={ldapLoading}>
              <Database className="mr-1 h-4 w-4" />
              {ldapLoading ? 'Synchronisiere…' : 'LDAP Sync'}
            </Button>
          ) : null}
          <Button size="sm" variant="outline" onClick={onToggleStudentList}>
            {showStudentList ? 'Liste ausblenden' : 'Liste anzeigen'}
          </Button>
        </>
      }
    />
  )
}
